var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDuplicateEntry = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 9 V5 a2 2 0 0 0 -2 -2 H6 a2 2 0 0 0 -2 2 V22 a2 2 0 0 0 2 2 H10"
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 9,
  width: 20,
  height: 22,
  rx: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 15,
  x2: 26,
  y2: 15
}), /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 20,
  x2: 26,
  y2: 20
}), /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 25,
  x2: 21,
  y2: 25
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDuplicateEntry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_duplicate_entry.218b66010035fe02ef08fc21d4d85021.svg";